var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-list"},[_vm._l((_vm.showList),function(item,i){return _c('div',{key:i,staticClass:"tag-item"},[_vm._v(_vm._s(item))])}),(_vm.showBtn)?_c('div',{class:['tag-item', 'expand-btn', _vm.expendStatus ? 'collapse' : 'expand'],on:{"click":_vm.expandChange}},[_vm._v("      ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }